import { useAppKit, useAppKitAccount } from "@reown/appkit/react";
import { trimAddress } from "../helper/constant";


export default function Connect() {
    const { open } = useAppKit();
    const { address, isConnected } = useAppKitAccount();


    return (
        address && isConnected ? (
            <button onClick={() => open()} type="button" className="cs-btn" >
                {trimAddress(address)}
            </button>
        ) : (
            <button onClick={() => open()} type="button" className="cs-btn" >
                Connect Wallet
            </button >
        )

    )
}